import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { WarningFilled } from '@ant-design/icons'

const SafeguardingBanner = () => {
  return (
    <BannerContainer>
      <StyledWarningFilled />
      <Text weight="medium">
        Safeguarding items are not available to users without safeguarding
        access
      </Text>
    </BannerContainer>
  )
}

export default SafeguardingBanner

const BannerContainer = styled.div`
  display: flex;
  gap: 10px;
  background-color: ${(props) => props.theme.color.neutral.color10};
  color: ${(props) => props.theme.color.neutral.color1};
  border-radius: 12px;
  padding: 8px 24px;
`

const StyledWarningFilled = styled(WarningFilled)`
  font-size: 16px;
  color: ${(props) => props.theme.color.status.warning};
`
